import React from "react";
import "./FeaturedHomes/FeaturedHomes.css";
import ongoing from "./FeaturedHomes/ongoing.jpg";
import residance from "./FeaturedHomes/residance.jpg";
import store from "./FeaturedHomes/store.jpg";
import villa from "./FeaturedHomes/villa.jpg";
import { Link } from "react-router-dom";

const FeaturedHomes = () => {
  return (
    <div className="featured-homes text-center mb-5">
      <h2 className="featured-title">Portföylerimiz</h2>
      <p className="featured-description">
        Geniş portföyümüz; rezidanslar, villalar ve ticari alanlardan oluşarak
        farklı ihtiyaçlara yönelik çözümler sunmaktadır. Avantajlı lokasyonlarda
        yer alan projelerimizi inceleyerek, sizin için en uygun yatırım
        fırsatlarını keşfedebilirsiniz.
      </p>
      <div className="row m-0 p-0 justify-content-center mt-4">
        <div className="col-lg-3 col-md-6 col-sm-12 featured-box m-0">
          <Link className="text-decoration-none" to="/projects/residence">
            <div className="featured-card">
              <img src={residance} alt="Featured Home" />
              <span>
                <div className="border-bottom">DAİRE</div>
                <div>REZİDANS</div>
              </span>
            </div>
          </Link>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 featured-box m-0">
          <Link className="text-decoration-none" to="/projects/villa">
            <div className="featured-card">
              <img src={villa} alt="Featured Home" />
              <span>VİLLA</span>
            </div>
          </Link>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 featured-box m-0">
          <Link className="text-decoration-none" to="/projects/store">
            <div className="featured-card">
              <img src={store} alt="Featured Home" />
              <span>
                <div className="border-bottom">DÜKKAN</div>
                <div>MAĞAZA</div>
              </span>
            </div>
          </Link>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12 featured-box m-0">
          <Link className="text-decoration-none" to="/projects/all">
            <div className="featured-card">
              <img src={ongoing} alt="Featured Home" />
              <span>
                <div className="border-bottom">DEVAM EDEN</div>
                <div>PROJELER</div>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedHomes;
